import { render, staticRenderFns } from "./136.vue?vue&type=template&id=10569b1d&scoped=true&"
var script = {}
import style0 from "./136.vue?vue&type=style&index=0&id=10569b1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10569b1d",
  null
  
)

export default component.exports